<template>
  <div>
    <div
      class="relative new-mode-header"
      :class="titleAlignmentClass"
      v-if="item.topLanguageMap && titleAlignment === 'TITLE_ALIGNMENT_CENTER'"
    >
      <div>
        <div class="title-left">
          <span class="title">{{ item.topLanguageMap?.title }}</span>
        </div>
        <!-- 副标题 -->
        <div class="title_sub">{{ item.topLanguageMap?.subTitle }}</div>
      </div>
    </div>
    <div class="mode10-wrap" :class="[IsMobile ? 'IsMobile' : '']">
      <el-skeleton :loading="skeletonLoading" animated :throttle="0">
        <template slot="template">
          <el-skeleton-item variant="image" style="width: 100%; height: 60px" />
        </template>
        <template>
          <div class="mode10-box">
            <div class="mode10-title" v-if="titleAlignment === 'TITLE_ALIGNMENT_LEFT'">
              <div class="title-left">
                <img
                  class="title-icon"
                  v-if="$utils.lang_data(lang, titleList, 'langInfoObj')"
                  :src="$utils.returnImgUrl($utils.lang_data(lang, titleList, 'langInfoObj')?.icon)"
                  alt="title-icon"
                  srcset=""
                />
                <span class="title">{{ $utils.lang_data(lang, titleList, "langInfoObj")?.name }}</span>
              </div>

              <div class="title-right" v-if="!IsMobile && lists && lists.length">
                <i
                  @click="cur_left > 0 ? changePosition('left') : ''"
                  :class="cur_left > 0 ? '' : 'disabled'"
                  class="icon-arrow-common el-icon-arrow-left"
                ></i>
                <i
                  :class="cur_left < max_left - 1 ? '' : 'disabled'"
                  @click="cur_left < max_left - 1 ? changePosition('right') : ''"
                  class="icon-arrow-common el-icon-arrow-right"
                ></i>
              </div>
            </div>
            <div class="content-row" :class="`content_${curindex}`" ref="row" v-if="lists && lists.length">
              <template v-for="(imgObj, index) in lists">
                <div
                  class="img-box"
                  :class="{ 'mr-0': (index + 1) % 7 === 0 }"
                  v-exposure="{ eid: imgObj.eid, jump_value: imgObj.jump }"
                  :data-id="imgObj.eid"
                  :key="imgObj.eid + index"
                >
                  <el-skeleton :loading="skeletonLoading" animated :throttle="0">
                    <template slot="template">
                      <el-skeleton-item variant="image" style="width: 100%; height: 100%" />
                    </template>
                    <template style="width: 100%">
                      <el-image
                        class="img"
                        @click="handelClick(imgObj)"
                        :src="$utils.returnImgUrl($utils.lang_data(lang, imgObj, 'langInfoObj')?.icon)"
                        v-if="$utils.lang_data(lang, imgObj, 'langInfoObj')?.icon && imgObj.isShow === 1"
                      ></el-image>
                    </template>
                  </el-skeleton>
                </div>
              </template>
            </div>
          </div>
        </template>
      </el-skeleton>
    </div>
  </div>
</template>

<script>
import mode10 from "@/lobby_common/mixins_views/homeModule/mode10.js";
export default {
  mixins: [mode10],
};
</script>
<style lang="scss" scoped>
.mode10-box {
  color: var(--font-color-100);

  .content-row {
    position: relative;
    display: flex;
    align-items: center;

    .img-box {
      position: relative;
      width: 13.3%;
      height: 60px;
      background-color: var(--background-900);
      border-radius: 5px;
      margin-right: 1%;
      transition: 0.5s;
      flex-shrink: 0;
      overflow: hidden;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

      &.mr-0 {
        margin-right: 0.9%;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .mode10-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 42px;
    margin-bottom: 10px;
    .title-left {
      height: 100%;
      display: flex;
      align-items: center;
    }

    .title-right {
      display: flex;
      align-items: center;

      .el-icon-arrow-left {
        width: 30px;
        cursor: pointer;
        border-radius: 5px;
      }

      .el-icon-arrow-right {
        width: 30px;
        cursor: pointer;
        border-radius: 5px;
        margin-left: 10px;
      }
    }

    .title-icon {
      width: 20px;
      margin: 0 10px 0 0;
    }
    .title {
      font-size: 18px;
    }
  }
}

.mode10-wrap {
  position: relative;
  overflow: hidden;
  min-height: 60px;

  &.IsMobile {
    .mode10-title {
      .title-icon {
        margin: 0 0 0 10px;
      }
      .title {
        font-size: 15px;
        margin-left: 10px;
      }
    }
    .mode10-box {
      .content-row {
        overflow-y: auto;
        padding-left: 10px;

        .img-box {
          width: 110px;
          height: 40px;
          margin-right: 7px;
          border-radius: var(--radius-401);

          .img {
            display: block;
            margin: 0 auto;
            width: 52px;
          }
        }
      }
    }
  }
}
</style>
